import { createContext, useContext } from "react";
import type { CustomerAccess } from "@/lib/access-control";

const DashboardAccessContext = createContext<CustomerAccess>({
  mode: "read-only",
  userId: null,
});

export const DashboardAccessProvider = DashboardAccessContext.Provider;

export function useDashboardAccess(): CustomerAccess {
  return useContext(DashboardAccessContext);
}
